/** Access token lives ~1h; refresh a minute earlier. Background tabs throttle timers. */
export const REFRESH_TOKEN_INTERVAL = 59 * 60 * 1000;
